if (!customElements.get('noyoco-editorial')) {
  customElements.define('noyoco-editorial', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.content = this.querySelector('[data-editorial-content]');
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-editorial-open]');
        if (link && typeof this.dialog.showModal === 'function') {
          const template = this.querySelector(`[id="${link.dataset.editorialOpen}"]`);
          if (!template) return;
          event.preventDefault();
          this.opener = link;
          this.content.replaceChildren(template.content.cloneNode(true));
          this.dialog.classList.toggle('editorial-archive__dialog--photo', this.classList.contains('editorial-archive--story'));
          this.previousOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          this.dialog.showModal();
          this.dialog.scrollTop = 0;
          this.dialog.querySelector('[data-editorial-close]').focus();
        }
        if (event.target.closest('[data-editorial-close]')) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => {
        this.content.querySelectorAll('video').forEach(video => video.pause());
        this.content.replaceChildren();
        document.documentElement.style.overflow = this.previousOverflow || '';
        this.opener?.focus({ preventScroll: true });
      });
    }
  });
}
